import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment-timezone'
import { motion, AnimatePresence } from 'framer-motion'

import { Check, RichText, Schedule, Property, Icon, Animation } from 'components'
import { TagBlock } from 'features'
import { itemContext, sectionContext, tagContext } from 'context'
import { FaCalendar, FaCheckDouble } from 'react-icons/fa'

import { scheduleString } from 'utils'

const TextContainer = styled.div`
    position: relative;
    padding: 0.5rem 0.5rem 0rem 0;
    z-index: 0;
    width: 100%;
    height: auto;
    overflow: visible;
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
    color: ${props => props.completed ? 'var(--secondary-accent-color)' : 'var(--text-color)'};
    transition: all 0.3s cubic-bezier(.55, 0, .1, 1);
    @media not all and (min-resolution:.001dpcm) { 
        -webkit-text-decoration-line: ${props => props.completed ? 'line-through' : null};
    };
    
    @media screen and (-webkit-min-device-pixel-ratio:0) and (min-resolution:.001dpcm) {
        text-decoration: ${props => props.completed ? 'line-through' : null};
        text-decoration-color: var(--secondary-accent-color);
        // text-decoration-thickness: 1rem; // Will cause issues for Firefox
    };
`

const PropertiesContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    /* grid-column: 2; */
    grid-column: ${props => props.type === 'search' ? '1/3' : 2};
`

const Wrapper = styled.div`
    cursor: pointer;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    width: ${props => `calc(100% - ${props.offset * 32}px)`};
    min-height: 1.5rem;
    position: relative;
    padding: 0.3rem 0.5rem;
    overflow: hidden;
    background-color: ${props => props.type !== 'search' ? '#474747' : 'transparent'};
    box-shadow: ${props => props.type !== 'search' && 'var(--box-shadow)'};
    margin-top: ${props => props.type !== 'search' && '0.5rem'};
`

const Container = styled.div`
    width: 100%;
    display: grid;
    grid-column-gap: 0.5rem;
    grid-template-columns: 1rem auto;
    grid-template-rows: auto auto;
`

const PrimaryButtons = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    grid-row: 1 / 2;
    align-self: start;
    padding-left: 0.5rem;
`

const PageTitle = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 0.2rem;
    align-items: center;
`

const ItemBlock = props =>  {
    const {
        item,
        type,
        animateProps
    } = props;
    // Constants //
    const completed = item['status'] === itemContext.STATUS.COMPLETED

    // Elements //
    const primaryButtons = <PrimaryButtons>
                                <Check filled={!!completed} onSelect={() => {}}
                                    color={!completed ? itemContext.PRIORITY_COLOR[item['priority']] : null}
                                    backgroundColor={completed ? itemContext.PRIORITY_COLOR[item['priority']] : null}
                                    borderColor={itemContext.PRIORITY_COLOR[item['priority']]}/>
                            </PrimaryButtons>

    const textElement = <TextContainer completed={completed}>
                            {/* {item['content']} */}
                            <RichText value={item['content']} readOnly disableAutoUpdate
                                styles={{
                                    primaryColor: type !== 'search' ? '#474747' : '#2B2B2B',
                                    secondaryColor: '#141414',
                                    padding: 0,
                                    margin: 0
                                }}/>
                        </TextContainer>
    
    let properties = []
    // Page name
    const page = item['page']
    if(page && type === 'search'){
        const pageTitle = <PageTitle>
                        <Icon size={'1rem'} value={page.icon ? page.icon.value : null} type={page.icon ? page.icon.type : null} styles={{padding: 0}}/>
                        {page['page_name']}
                    </PageTitle>
        properties.push(<Property key={uuidv4()} label={pageTitle} style={{padding: '0.1rem'}}/>)
    }

    // Children count
    item['children'] && properties.push(
        <Property icon={<FaCheckDouble/>} 
                        onSelect={() => {}}
                        label={`${item['children']['completed']}/${item['children']['total']}`}/>
    )
    

    // Dates
    const itemDates = {
        start_date: item['start_date'],
        end_date: item['end_date'],
        start_time: item['start_time'],
        end_time: item['end_time']
    }
    const timezone = moment.tz.guess()
    const schedule = scheduleString(itemDates, timezone);
    if(schedule.valid){
        const dates = {
            start_date: item.start_date ? moment(item.start_date).tz(timezone) : null,
            end_date: item.end_date ? moment(item.end_date).tz(timezone) : null, 
            start_time: item.start_time ? moment(item.start_time).tz(timezone) : null,
            end_time: item.end_time ? moment(item.end_time).tz(timezone) : null
        }
        properties.push(<Property key={uuidv4()}  
                            icon={<FaCalendar/>} tooltip='Schedule' 
                            label={<Schedule dates={{start: schedule.start, end: schedule.end}}/>}/>)
    }

    // Tags
    item['tags'] && item['tags'].map(tag => {
        properties.push(<TagBlock tag={tag} style={{margin: '0.2rem'}}/>)
    })

    
    // Render // 
    return (
        <Wrapper offset={item['offset']} type={type}>
            <Container>
                {primaryButtons}
                {textElement}
                {/* {!edit && !this.props.disableButtons ? secondaryButtons : null} */}
                <span/>
                {animateProps ? 
                <AnimatePresence>
                    {properties.length > 0 && 
                        <Animation animation='expand' duration={0.5}>
                            <PropertiesContainer type={type}>{properties}</PropertiesContainer>
                        </Animation>}
                </AnimatePresence>
                : <PropertiesContainer>{properties}</PropertiesContainer>
            }
                
            </Container>
        </Wrapper>
    )
}


export default ItemBlock;
